"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MLSSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M8.7 4l-3-2a.5.5 0 00-.5 0l-3 2a.5.5 0 00-.2.5v5a.5.5 0 00.5.5h2V6.5h2V10h2a.5.5 0 00.5-.5v-5a.5.5 0 00-.3-.5zM8.7 14l-3-2a.5.5 0 00-.5 0l-3 2a.5.5 0 00-.3.5v5a.5.5 0 00.6.5h2v-3.5h2V20h2a.5.5 0 00.4-.5v-5a.5.5 0 00-.2-.4zM8.7 24l-3-2a.5.5 0 00-.5 0l-3 2a.5.5 0 00-.3.5v5a.5.5 0 00.6.5h2v-3.5h2V30h2a.5.5 0 00.4-.5v-5a.5.5 0 00-.2-.4z"/><rect x="13" y="5" width="17" height="4" rx="2"/><rect x="13" y="14" width="17" height="4" rx="2"/><rect x="13" y="23" width="17" height="4" rx="2"/>';
var MLSSVG = function MLSSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.MLSSVG = MLSSVG;
MLSSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(MLSSVG);
exports.default = _default;